import React from 'react'
import { Link } from 'react-router-dom'
import { Container } from './components/Container'

interface Props {
  action?: string
  image?: string
  title?: string
  link: string
  subtitle?: string
}

export const PostTile: React.FC<Props> = ({
  title,
  action = 'Read More',
  link,
  image,
  subtitle
}) => {
  return (
    <Container>
      <div className='item'>
        <Link to={link}>
          <div
            className='image'
            style={{
              backgroundImage: `url(${image})`
            }}
          />
          <div className='content'>
            <div className='title'>
              {title}
            </div>
            <div className='subtitle'>
              {subtitle}
            </div>
            <div className='action'>
              <span>
                {action}
              </span>
            </div>
          </div>
        </Link>
      </div>
    </Container>
  )
}
